import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M45 30.1C45 22.9 39.1 17 31.9 17h-4.7v2.5h4.7c5.9 0 10.6 4.8 10.6 10.6s-4.8 10.6-10.6 10.6h-25v-6H32c2.5 0 4.6-2.1 4.6-4.6 0-2.5-2.1-4.6-4.6-4.6h-4.5V28H32c1.2 0 2.1.9 2.1 2.1 0 1.2-.9 2.1-2.1 2.1H7v-1.8H0V45h6.8v-1.8h25.1c7.2 0 13.1-5.9 13.1-13.1zM4.3 42.5H2.5v-9.6h1.8v9.6z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M38.1 0v1.8h-25C5.9 1.8 0 7.6 0 14.9S5.9 28 13.1 28h3.4v.4c0 .7.6 1.3 1.3 1.3h9.3c.7 0 1.3-.6 1.3-1.3V16.5c0-.7-.6-1.3-1.3-1.3h-9.3c-.7 0-1.3.6-1.3 1.3v.5h-3.4c-1.2 0-2.1-1-2.1-2.1 0-1.2.9-2.1 2.1-2.1h25v1.8H45V0h-6.9zM19 17.7h7v9.6h-7v-9.6zm-5.9-7.4c-2.5 0-4.6 2.1-4.6 4.6 0 2.5 2.1 4.6 4.6 4.6h3.4v6h-3.4c-5.9 0-10.6-4.8-10.6-10.6S7.3 4.3 13.1 4.3h25v6h-25zm29.4 1.8h-1.8V2.5h1.8v9.6z"
	})]
});
export default SvgIcon;
